import { useScanner } from '../../../hooks/scanner.hook'
import { useEffect } from 'react'
import { useGoToInventoryProductList } from '../product-list/InventoryProductList.navigator'
import { manageError } from '../../../utils/errors/error.handler'
import { validateScan } from './ScanContainerLocation.validator'
import { getLocationOrContainerFromScan } from 'client/scanner/scanner.client'
import { useAtom } from 'jotai'
import { inventoryFixOriginInfoAtom } from '../InventoryFix.state'
import { ScanType } from 'client/scanner/scanner.types'
import { useGoToScanContainer } from '../scan-container/ScanContainer.navigator'

export const useScanContainerLocation = () => {
  const {
    keys,
    getScan
  } = useScanner()
  const inventoryProductList = useGoToInventoryProductList()
  const scanContainer = useGoToScanContainer()
  const [, setOrigin] = useAtom(inventoryFixOriginInfoAtom)

  useEffect(() => {
    const scanned = getScan()
    if (scanned) {
      getLocationOrContainerFromScan(scanned)
        .then(validateScan)
        .then(origin => {
          if (origin.type === ScanType.Location && origin.totalContainers > 1) {
            scanContainer.go(origin.location.name)
          }
          else{
            setOrigin(origin)
            inventoryProductList.go(origin)
          }    
        })
        .catch(manageError(`ScanContainerLocation.hooks.ts#useEffect ${scanned}`))
    }
  }, [keys])

}
